angular.module('app').component('reportNav', {
    templateUrl: 'scripts/app/partials/reports/ReportNav.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: function ($window, $location, RouteService, UserDetailsApi // TODO: Use UserDetails
    ) {
        let vm = this;
        vm.nav = nav;
        vm.startsWith = startsWith;
        vm.$onInit = function () {
            vm.path = $location.path();
            UserDetailsApi.get().then(function (user) {
                vm.userDetails = user;
            });
        };
        function nav(dest) {
            RouteService.buildRoute(dest).then(function (route) {
                console.log(route, 'ReportNav route');
                this.location = route;
                $window.location.href = route;
            });
        }
        function startsWith(currentPath) {
            let path = $location.path();
            return _.startsWith(path, currentPath);
        }
    }
});
